
[
  {
    "id": "TG-E7-L205-001",
    "module": "TijdGeld",
    "difficulty": 205,
    "question": "Wat is voordeliger? 500 gram voor € 2,40 of 750 gram voor € 3,50?",
    "options": ["750 gram voor € 3,50", "500 gram voor € 2,40", "Even duur", "Niet te berekenen"],
    "correctAnswer": 0,
    "questionType": "multiple_choice",
    "skill": "geld_rekenen",
    "subSkill": "prijzen_vergelijken",
    "familyId": "TG-PRIJS-KG",
    "explanation": "500g = € 2,40 -> 250g = € 1,20. 750g = € 3,50 -> 250g = € 1,16. De tweede is goedkoper.",
    "distractorExplanations": { "1": "Dat is duurder per gram.", "2": "Nee, er is een verschil.", "3": "Jawel, reken terug naar 250 gram." }
  },
  {
    "id": "TG-E7-L205-002",
    "module": "TijdGeld",
    "difficulty": 205,
    "question": "Hoeveel dagen heeft het eerste kwartaal van een schrikkeljaar?",
    "options": ["91 dagen", "90 dagen", "92 dagen", "89 dagen"],
    "correctAnswer": 0,
    "questionType": "multiple_choice",
    "skill": "kalender",
    "subSkill": "kalender_schrikkel",
    "familyId": "TG-KWARTAAL-1",
    "explanation": "Jan (31) + Feb (29, schrikkel) + Mrt (31) = 91 dagen.",
    "distractorExplanations": { "1": "Dat is in een gewoon jaar (feb 28).", "2": "Te veel.", "3": "Te weinig." }
  },
  {
    "id": "TG-E7-L205-003",
    "module": "TijdGeld",
    "difficulty": 205,
    "question": "Je leent € 500 en betaalt 6% rente per jaar. Hoeveel rente betaal je in 4 maanden?",
    "options": ["€ 10", "€ 30", "€ 120", "€ 20"],
    "correctAnswer": 0,
    "questionType": "multiple_choice",
    "skill": "financieel",
    "subSkill": "rente",
    "familyId": "TG-RENTE-MAAND",
    "explanation": "6% van 500 = 30 euro per jaar. 4 maanden is 1/3 jaar. 1/3 van 30 = 10 euro.",
    "distractorExplanations": { "1": "Dat is de jaarrente.", "2": "Dat is over 4 jaar.", "3": "Dat is over 8 maanden." }
  },
  {
    "id": "TG-E7-L205-004",
    "module": "TijdGeld",
    "difficulty": 205,
    "question": "Een auto rijdt 100 km/u. Hoe lang doet hij over 25 km?",
    "options": ["15 minuten", "25 minuten", "20 minuten", "30 minuten"],
    "correctAnswer": 0,
    "questionType": "multiple_choice",
    "skill": "snelheid",
    "subSkill": "snelheid_berekenen",
    "familyId": "TG-KMU-TIJD",
    "explanation": "25 km is een kwart van 100 km. Een kwart uur is 15 minuten.",
    "distractorExplanations": { "1": "Je hebt de km als minuten genomen.", "2": "Schattingsfout.", "3": "Dat is voor 50 km." }
  },
  {
    "id": "TG-E7-L205-005",
    "module": "TijdGeld",
    "difficulty": 205,
    "question": "Wat is het gemiddelde uurloon als je € 120 verdient in 8 uur?",
    "options": ["€ 15,00", "€ 12,00", "€ 14,00", "€ 16,00"],
    "correctAnswer": 0,
    "questionType": "multiple_choice",
    "skill": "financieel",
    "subSkill": "loon",
    "familyId": "TG-LOON-UUR",
    "explanation": "120 : 8 = 15.",
    "distractorExplanations": { "1": "Rekenfout.", "2": "Rekenfout.", "3": "Rekenfout." }
  }
]
